import { useCallback, useEffect, useState } from 'react';
import { useClientTagsQuery } from 'api';
import { FormInstance } from 'components';

export const VERIFIED_STATUS = [
  {
    value: '',
    label: 'All',
  },
  {
    value: true,
    label: 'Verified',
  },
  {
    value: false,
    label: 'Not Verified',
  },
];

export const useFilterDrawer = ({ form, resetFilters }: { form: FormInstance; resetFilters: () => void }) => {
  const { data: tagData = [], isSuccess: isTagSuccess } = useClientTagsQuery();
  const [availableTags, setAvailableTags] = useState<string[]>([]);

  const handleTagSelect = useCallback((tag: string) => {
    setAvailableTags((prevState) => prevState.filter((_tag) => _tag !== tag));
  }, []);

  const handleTagRemove = useCallback((tag: string) => {
    setAvailableTags((prevState) => [tag, ...prevState]);
  }, []);

  const clearFilters = useCallback(() => {
    form.resetFields();
    setAvailableTags(tagData);
    resetFilters();
  }, [form, tagData, resetFilters]);

  const clearFieldValidation = (form: FormInstance, field: string) => {
    const hasError = form.getFieldError(field)?.length;
    if (hasError) {
      form.setFields([
        {
          name: field,
          errors: [], // Clears the error for filed
        },
      ]);
    }
  };

  useEffect(() => {
    if (isTagSuccess) {
      setAvailableTags(tagData);
    }
  }, [isTagSuccess, tagData]);

  return {
    availableTags,
    handleTagSelect,
    handleTagRemove,
    clearFilters,
    clearFieldValidation,
  };
};
